import { useCallback, useMemo } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { SessionActions } from "stores/sessions/SessionStore";
import Routes from "routing/Routes";
import useHistory from "routing/useHistory";
import usePluginEntities from "hooks/usePluginEntities";
const logout = () => SessionActions.logout().then(() => SessionActions.validate);
const wrapHooks = (hooks) => () => Promise.allSettled(
  hooks.map(async (hook) => {
    try {
      await hook();
    } catch (e) {
      console.error("Error in logout hook: ", e);
    }
  })
);
const useLogout = () => {
  const history = useHistory();
  const queryClient = useQueryClient();
  const logoutHooks = usePluginEntities("hooks.logout");
  const logoutHook = useMemo(() => wrapHooks(logoutHooks), [logoutHooks]);
  return useCallback(
    () => logoutHook().then(logout).then(() => {
      queryClient.removeQueries({ queryKey: ["streams"] });
    }).then(() => history.push(Routes.STARTPAGE)),
    [history, logoutHook, queryClient]
  );
};
export default useLogout;
